export default {
  path: "/SectionContent/ReportingFatalCrashes",
  name: "Reporting Fatal Crashes",
  htmlContent: "reporting_fatal_crashes.html",
};
